export const DIAL_PLAN_RULE_SETS = ["DOMESTIC", "INTERNATIONAL"];

export const INITIAL_ICF_STATE = Object.freeze({
  allowServiceExtensions: false,
  maxCallForwarding: "0",
  allowTransfers: false,
});

export const INITIAL_ICF_ERRORS = Object.freeze({
  allowServiceExtensions: null,
  maxCallForwarding: null,
  allowTransfers: null,
});
